import { render, staticRenderFns } from "./AppCoreHeader.vue?vue&type=template&id=3b78e5b0&"
import script from "./AppCoreHeader.vue?vue&type=script&lang=js&"
export * from "./AppCoreHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b78e5b0')) {
      api.createRecord('3b78e5b0', component.options)
    } else {
      api.reload('3b78e5b0', component.options)
    }
    module.hot.accept("./AppCoreHeader.vue?vue&type=template&id=3b78e5b0&", function () {
      api.rerender('3b78e5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ui/header/AppCoreHeader.vue"
export default component.exports